var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-no-access-page mit-page"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-left",attrs:{"cols":"12"}},[_c('div',{staticClass:"pa-2"},[_c('h3',{staticClass:"pb-2"},[_vm._v("No Access")]),_c('p',[_vm._v("You do not have permission to access this page.")])])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }